
import { commonData } from './mixin'
import {formatTime} from '@/utils/util'
import FooterBar from '@/components/FooterBar'
import ToTop from '@/components/ToTop'
import MainTemp from '@/components/MainTemp'
import ScrollBar from './components/ScrollBar'
import Pagination from './components/Pagination'
import UserMoney from './components/UserMoney'
import GoBack from './components/GoBack'
import ScanCode from './components/ScanCode'
import SearchBox from './components/SearchBox'
import PayBill from './components/PayBill'
import ExportDianlog from '@/components/ExportDianlog'
import CustomerService from '@/components/CustomerService'
export default {
    install(Vue) {
        // 1. 添加全局过滤器

        // 格式化数字类型的日期为0000-00-00 
        Vue.filter('formatTime', function (strDate) {
            var dateStr = strDate
            if (dateStr) {
                var year = dateStr.slice(0, 4)
                var month = dateStr.slice(4, 6)
                var day = dateStr.slice(6);
                var formatted = year + "-" + month + "-" + day
                return formatted
            }

        })

        // 格式化数时间戳
        Vue.filter('timestamp', function (time) {
            let date = time * 1000
            return formatTime(date)
        })

        // 去除CN
        Vue.filter('substring', function (str) {
            return str.slice(2);
        })

        // 根据专利号判断类型前缀CN
        Vue.filter('istpye', function (strs) {
            if (strs) {
                var type = strs.slice(6, 7)
                if (type == "1" || type == "8") {
                    return "发明专利"
                } else if (type == "2" || type == "9") {
                    return "实用新型"
                } else if (type == "3") {
                    return "外观设计"
                } else {
                    return "其它类型"
                }
            }
        })

        // 根据专利号判断类型无前缀CN
        Vue.filter('Formattype', function (numbers) {
            if (numbers) {
                var type = numbers.slice(4, 5)
                if (type == "1" || type == "8") {
                    return "发明专利"
                } else if (type == "2" || type == "9") {
                    return "实用新型"
                } else if (type == "3") {
                    return "外观设计"
                } else {
                    return "其它类型"
                }
            }
        })



        // 2. 添加全局指令
        Vue.directive()

        // 3. 配置全局混入(合)
        Vue.mixin(commonData)

        // 注册全局组件 Footer.name是引入模块的中的name
        Vue.component(FooterBar.name, FooterBar)
        Vue.component(ToTop.name, ToTop)
        Vue.component(MainTemp.name, MainTemp)
        Vue.component(ScrollBar.name, ScrollBar)
        Vue.component(Pagination.name, Pagination)
        Vue.component(UserMoney.name, UserMoney)
        Vue.component(GoBack.name, GoBack)
        Vue.component(ScanCode.name, ScanCode)
        Vue.component(SearchBox.name, SearchBox)
        Vue.component(PayBill.name, PayBill)
        Vue.component(ExportDianlog.name, ExportDianlog)
        Vue.component(CustomerService.name, CustomerService)
        // 4. 添加实例方法和属性
        Vue.prototype.$myMethod = function () { }
        Vue.prototype.$Confirm = function (tips) { 
            return new Promise((resolve)=>{
                this.$confirm(tips)
                .then(()=>{
                   resolve(true)
                }).catch(()=>{
                    resolve(false)
                })
            })
        }
        Vue.prototype.$myProperty = 'xxxx'
    }
}
